import { useI18n, LangToggle } from "../i18n";

// Cloud agents are provisioned with a managed key/model, so settings only
// exposes the UI language — no API key / model / provider reset here.
export function SettingsModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { t } = useI18n();

  if (!open) return null;

  return (
    <div className="modal-root" role="dialog" aria-modal="true" aria-label={t("settings.title")}>
      <div className="modal-scrim" onClick={onClose} />
      <div className="modal-card">
        <div className="modal-head">
          <span className="modal-title">{t("settings.title")}</span>
          <button type="button" className="icon-btn" onClick={onClose} aria-label={t("common.close")} title={t("common.close")}>
            ×
          </button>
        </div>
        <div className="modal-body">
          <div className="settings-lang-row">
            <span className="label settings-lang-label">{t("settings.language")}</span>
            <LangToggle />
          </div>
        </div>
      </div>
    </div>
  );
}
